import React from 'react'
import { 
  CardsView,
  CardWrapper,
  Header,
  MainContent, 
  MainWrapper
} from './styles';
import isMobile from 'tcp-common/lib/utils/is-mobile'
import Card from './Card';

const FeesSection = () => {
    const isMobileView = isMobile()

    const cardContent = () => <>
      <Card
        cardHeader='NeuCard Infinity'
        cardFee='Joining fee'
        cardStrikeAmount='₹1,499'
        cardAmount='₹0'
        cardCreditedHighlight='Zero joining fee'
        cardCredited='offer for limited time only'
        cardRenewalFee='Renewal fee'
        cardRenewalAmount='₹1499 + GST'
        cardFeeWaived='*Renewal Fee of Rs. 1,499 waived off on spends of Rs 3 lakh or more in the preceding year'
      ></Card>
      <Card
        cardHeader='NeuCard Plus'
        cardFee='Joining fee'
        cardStrikeAmount='₹499'
        cardAmount='₹0'
        cardCreditedHighlight='Zero joining fee'
        cardCredited='offer for limited time only'
        cardRenewalFee='Renewal fee'
        cardRenewalAmount='₹499 + GST'
        cardFeeWaived='*Renewal Fee of Rs. 499 waived off on spends of Rs 1 lakh or more in the preceding year'
      ></Card>
    </>

    const renderDesktopView = () => <MainWrapper>
        <MainContent flexDirection='column'>
           <Header>
           NeuCard Joining and Renewal Fees
           </Header>
           <CardsView flexDirection='row' justifyContent='space-between'>
           <CardWrapper>
            {cardContent()}
            </CardWrapper>
          </CardsView>
          {/*<InterestedButton onClick={()=>redirectProductDetail('Joining & Renewal Fees')}>
              <ButtonText>Apply Now</ButtonText>
</InterestedButton>*/}
        </MainContent>
    </MainWrapper>

    const renderMobileView = () => <MainWrapper flexDirection='column'>
        <MainContent flexDirection='column'>
           <Header>
           NeuCard Joining and Renewal Fees
           </Header>
           
            {cardContent()}
            
          {/*<InterestedButton onClick={()=>redirectProductDetail('Joining & Renewal Fees')}>
              <ButtonText>Apply Now</ButtonText>
</InterestedButton>*/}
        </MainContent>
        
    </MainWrapper>

    const renderView = () => isMobileView ? renderMobileView() : renderDesktopView()
    
    return renderView();
}

export default FeesSection
